import { render, staticRenderFns } from "./BranchName.vue?vue&type=template&id=0e01eb70&scoped=true&"
import script from "./BranchName.vue?vue&type=script&lang=js&"
export * from "./BranchName.vue?vue&type=script&lang=js&"
import style0 from "./BranchName.vue?vue&type=style&index=0&id=0e01eb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e01eb70",
  null
  
)

export default component.exports